import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=9877e19c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9877e19c')) {
      api.createRecord('9877e19c', component.options)
    } else {
      api.reload('9877e19c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=9877e19c&", function () {
      api.rerender('9877e19c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24N98mfpOBa4T/JS/comp/ImgFallback.vue"
export default component.exports